import React from 'react';

const GeneralContent = () => (
  <section className='general-content'>
    <div className='container'>
      <div className='general-content__content'>
        <h2 className='general-content__title'>
          We’re only
          <br />
          just getting started.
        </h2>
        <div className='general-content__description'>
          <p>
            {' '}
            Join our squad and get in on the ground floor of a company with a big mission that’s never been
            more
            relevant—and help make the world a better place for all air breathers.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default GeneralContent;
